define('components/asset-player/radio-channel',[
    'components/radio-channel/radio-channel'
], function (RadioChannel) {
    "use strict";

    var channelName = 'asset-player',
        eventHash;

    eventHash = {
        "RENDER": null,

        "Mute": {
            "CHANGE": null,
            "GET": null,
            "SUPPORTED": null,
            "TOGGLE": null
        },

        "Transcript": {
            "CHANGE": null,
            "GET": null,
            "TOGGLE": null
        }
    };

    return RadioChannel.create(channelName, eventHash);
});

